import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../alert/alert.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { formatErrorList } from '../alert/format-error-list';
import { SubscriptionsManager } from '../util/subscriptions-manager';
import { ColumnCategory, ColumnModel } from './model/column.model';
import { QueryService } from './service/query.service';
import { GermplasmPairTraitModel } from '../../head-to-head-query/model/germplasm-pair-trait.model';


@Component({
    selector: 'jhi-columns-dropdown',
    templateUrl: './columns-dropdown.component.html',
    styleUrls: [
        './columns-dropdown.component.scss'
    ]
})
export class ColumnsDropdownComponent implements OnInit {

    subscriptionManager = new SubscriptionsManager();
    @Input() traits: GermplasmPairTraitModel[];
    @Input() selectedTraits: number[];
    @Input() environmentIds: number[] = [];
    @Input() staticColumns: ColumnModel[] = [];
    @Input() showEnvironmentsLabel = true;

    @Output() columnsSelectedEvent = new EventEmitter<ColumnModel[]>();

    @ViewChild('columnsDropdown', { static: true }) columnsDropdown: NgbDropdown;

    environmentVariableColumns: ColumnModel[] = [];
    traitColumns: ColumnModel[] = [];

    constructor(private queryService: QueryService,
                private alertService: AlertService) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['selectedTraits'] && this.selectedTraits && this.selectedTraits.length) {
            this.subscriptionManager.add = this.queryService.getEnvironmentColumns(this.selectedTraits, this.environmentIds).subscribe(
                (res: HttpResponse<ColumnModel[]>) => this.onGetColumnsSuccess(res.body)
            );
        }
    }

    apply() {
        this.columnsDropdown.close();
        this.columnsSelectedEvent.emit(this.concatAllColumns());
    }

    onSearchColumn(evt: any) {
        const searchString = evt.target.value.toLowerCase();
        if (searchString) {
            this.filterColumns(this.concatAllColumns(), searchString);
        } else {
            this.resetColumns();
        }
    }

    checkAreColumnsVisible(columns: ColumnModel[]): boolean {
        return columns.filter((column: ColumnModel) => column.visible).length > 0;
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    private transformEnvironmentColumns(columns: ColumnModel[]): ColumnModel[] {
        return columns.map((column: ColumnModel) =>
            new ColumnModel(column.id,
                column.name,
                ColumnCategory.VARIABLE,
                column.selected,
                null));
    }

    private onGetColumnsSuccess(columns: ColumnModel[]) {
        this.environmentVariableColumns = this.transformEnvironmentColumns(columns);
        this.traitColumns = [];
        this.traits.forEach((trait) => {
            const traitColumn = new ColumnModel();
            traitColumn.id = trait.variableId;
            traitColumn.name = trait.variableName;
            traitColumn.category = ColumnCategory.VARIABLE;
            traitColumn.selected = true;
            this.traitColumns.push(traitColumn);
        });
        this.resetColumns();
    }

    private concatAllColumns(): ColumnModel[] {
        return [].concat(this.staticColumns, this.environmentVariableColumns, this.traitColumns);
    }

    private filterColumns(columns: ColumnModel[], searchString: string) {
        columns.forEach((column: ColumnModel) => {
            if (!column.name.toLowerCase().includes(searchString.toLowerCase())) {
                column.visible = false;
            }
        });
    }

    private resetColumns() {
        this.concatAllColumns().forEach((column: ColumnModel) => column.visible = true);
    }

}
